// src/components/MicroLessonCard.jsx
import React from "react";

export default function MicroLessonCard({ micro, onContinue }) {
  if (!micro) return null;

  return (
    <div
      id="micro-lesson-card"
      style={{
        marginTop: "2rem",
        padding: "1.5rem",
        borderRadius: "16px",
        background: "#fff8e6",
        border: "1px solid #f2d9a6",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
      }}
    >
      <div
        style={{
          fontSize: "1.25rem",
          fontWeight: 600,
          marginBottom: "0.75rem",
          color: "#a86f00",
        }}
      >
        🔎 Mini Lesson: {micro.title}
      </div>

      <ul style={{ paddingLeft: "1.2rem", color: "#5a4a2f", lineHeight: 1.55 }}>
        {micro.content?.map((line, idx) => (
          <li key={idx} style={{ marginBottom: "0.45rem" }}>
            {line}
          </li>
        ))}
      </ul>

      <button
        onClick={onContinue}
        style={{
          marginTop: "1.2rem",
          padding: "0.7rem 1.1rem",
          background: "#ff9f1c",
          color: "white",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "1rem",
          fontWeight: 600,
        }}
      >
        Continue →
      </button>
    </div>
  );
}
